import type { CustomFlowbiteTheme } from 'flowbite-react';

export const CustomTheme: CustomFlowbiteTheme = {
    button: {
        color: {
            primary: 'bg-primary-500 hover:bg-primary-550 text-white',
            dark: 'bg-gray-700 hover:bg-gray-800 text-white',
            outline: 'bg-transparent border border-gray-300 hover:border-primary-500 hover:text-primary-500',
            help: 'border border-orange-600 text-orange-600 hover:bg-orange-100 hover:border-orange-400',
        },
    },
    textInput: {
        field: {
            input: {
                base: 'block w-full border disabled:cursor-not-allowed disabled:opacity-50 transition-all duration-200 cursor-pointer focus:cursor-auto',
                colors: {
                    default: 'bg-white border-gray-400 hover:border-primary-500 focus:border-primary-500',
                }
            }
        }
    },
    select: {
        field: {
            select: {
                base: 'block w-full border disabled:cursor-not-allowed disabled:opacity-50 transition-all duration-200 cursor-pointer focus:cursor-auto',
                colors: {
                    default: 'bg-white border-gray-400 hover:border-primary-500 focus:border-primary-500',
                }
            }
        }
    },
    textarea: {
        base: 'block w-full rounded-lg border text-sm disabled:cursor-not-allowed disabled:opacity-50 transition-all duration-200 cursor-pointer focus:cursor-auto',
        colors: {
            default: 'bg-white border-gray-400 hover:border-primary-500 focus:border-primary-500',
        }
    },
    modal: {
        root: {
            base: 'fixed inset-x-0 top-0 z-[1001] h-screen overflow-y-auto overflow-x-hidden md:inset-0 h-full'
        },
        content: {
            base: 'relative h-auto w-full p-4'
        }
    }
};
